
import React, { PropTypes, Component } from 'react'

import './ColoniaAutocomplete.scss'
import Geosuggest from 'components/Geosuggest'

class ColoniaAutocomplete extends Component {
  constructor (props) {
    super(props)

    this.setActiveSuggestion = this.setActiveSuggestion.bind(this)
    this.selectActiveSuggestion = this.selectActiveSuggestion.bind(this)

    this.state = {
      activeSuggestion: undefined
    }
  }

  setActiveSuggestion (suggest) {
    this.setState({ activeSuggestion: suggest })
  }

  selectActiveSuggestion () {
    const { activeSuggestion } = this.state
    if (activeSuggestion) {
      this._geosuggest.selectSuggest(activeSuggestion)
    }
  }

  render () {
    const {
      onSelect: handleSelect,
      getRef,
      onFocus
    } = this.props

    return (
      <div className='ColoniaAutocomplete'>
        <Geosuggest
          ref={(el) => {
            getRef(el)
            this._geosuggest = el
          }}
          placeholder='Escribe tu colonia'
          className='ColoniaAutocomplete-geosuggest'
          onSuggestSelect={handleSelect}
          onActivateSuggest={this.setActiveSuggestion}
          ignoreTab
          autoActivateFirstSuggest
          onFocus={onFocus}
          />
      </div>
    )
  }
}

ColoniaAutocomplete.displayName = 'ColoniaAutocomplete'
ColoniaAutocomplete.propTypes = {
  onSelect: PropTypes.func.isRequired,
  getRef: PropTypes.func.isRequired,
  onFocus: PropTypes.func
}
ColoniaAutocomplete.defaultProps = {
  onFocus: () => {}
}

export default ColoniaAutocomplete



// WEBPACK FOOTER //
// ./src/screens/App/screens/Home/components/ColoniaAutocomplete/ColoniaAutocomplete.js